import axios from 'axios';
import { url } from '../config';

// Redux Actions
import { FETCH_POSTS, FETCH_POSTS_START } from '../actions/index.jsx';

// Axios Request
export function fetchPosts(post_type = 'posts') {
    return function (dispatch) {
        dispatch({ type: FETCH_POSTS_START });
        axios.get(`${url}/wp-json/wp/v2/${post_type}`).then((response) => {
            dispatch({
                type: FETCH_POSTS,
                payload: response.data,
            });
        });
    };
}



// WEBPACK FOOTER //
// ./src/requests/posts_request.js